import React, { useEffect, useState } from "react";
import { Modal, Button } from "antd";
import * as XLSX from "xlsx";
import approveIcon from "@assets/SVG/approve.svg";
import { Icon } from "@iconify/react";

interface SubmitConfirmModalProps {
  open: boolean;
  onClose: () => void;
  onSubmit: () => Promise<void> | void;
  file: any;
}

const ExcelModal = ({ onSubmit, file, open, onClose }: SubmitConfirmModalProps) => {
  const [excelData, setExcelData] = useState<Record<string, any>[]>([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (file) {
      readExcelFile(file);
    }
  }, [file]);

  const readExcelFile = (file: File) => {
    if (!(file instanceof Blob)) {
      console.error("The provided file is not a Blob.");
      return;
    }
  
    const reader = new FileReader();
    reader.onload = (e) => {
      const data = new Uint8Array(e.target?.result as ArrayBuffer);
      const workbook = XLSX.read(data, { type: "array" });
      const worksheet = workbook.Sheets[workbook.SheetNames[0]];
      const jsonData = XLSX.utils.sheet_to_json<Record<string, any>>(worksheet);
      setExcelData(jsonData);
    };
    reader.readAsArrayBuffer(file);
  };
  

  const handleSend = async () => {
    setLoading(true);
    try {
      await onSubmit();
      onClose();
    } catch (err) {
      console.error("Submission failed", err);
    } finally {
      setLoading(false);
    }
  };

  const handleCancel = () => {
    onClose();
  };

  return (
    <Modal
      open={open}
      maskClosable={true}
      centered
      width={420}
      title="Excel File Preview"
      onCancel={handleCancel}
      footer={[
        <div className="flex items-center w-full justify-center -mt-6 mb-4 text-center">
          <Button
            type="default"
            onClick={handleCancel}
          >
            No, Cancel
          </Button>
          <Button
            type="primary"
            onClick={handleSend}
          >
            {loading && (
              <Icon
                icon={"mdi:loading"}
                width="12"
                height="12"
                className="animate-spin mr-1"
              />
            )}
            Yes, Proceed
          </Button>
        </div>
      ]}
    >
      <div className="text-center flex flex-col items-center">
        <img
          src={approveIcon}
          alt="Modal Icon"
          className={`h-16 mb-4`}
        />
        <h2
          className="text-xl font-semibold  mb-4"
        >
          {file?.file?.name} 
        </h2>
        <p className="text-xs text-[#51505D]">
            Are you sure to send request?
          </p>
      </div>
      {/* <div style={{ maxHeight: "400px", overflowY: "auto" }}>
        <table>
          <thead>
            <tr>
              {excelData.length > 0 &&
                Object.keys(excelData[0]).map((header) => (
                  <th key={header}>{header}</th>
                ))}
            </tr>
          </thead>
          <tbody>
            {excelData.map((row, rowIndex) => (
              <tr key={rowIndex}>
                {Object.values(row).map((cell, cellIndex) => (
                  <td key={cellIndex}>{String(cell)}</td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      </div> */}
    </Modal>
  );
};

export default ExcelModal;
